import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import Message from '../Common/Message/Message';
import Help from '../Common/Help/Help';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class CreateUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                username: '',
                password: '',
                first_name: '',
                last_name: '',
                email: '',
                role: 'box-office',
                active: true,
                id: null
            },
            login_type: '',
            password: null,
            validation: {
                first_name: {
                    valid: null,
                    msg: ''
                },
                last_name: {
                    valid: null,
                    msg: ''
                },
                username: {
                    valid: null,
                    msg: ''
                },
                email: {
                    valid: null,
                    msg: ''
                }
            },
            isReadyToSubmit: false,
            title: this.props.routeProps.match.params.id ? strings.edit : strings.create,
            button: this.props.routeProps.match.params.id ? strings.update : strings.save,
            isEditMode: this.props.routeProps.match.params.id ? true : false,
            isMyProfile: false,
            googleButtonFaded: false,
            message: {
                title: '',
                content: '',
                type: ''
            }
        }
    }

    handleChangePassword = (e) => {
        let value = e.target.value;
        let password = { ...this.state.password };
        password = value;
        this.setState({
            password,
            login_type: ''
        });
    }

    handleChange = (e) => {
        let value = e.target.value;
        const name = e.target.name;
        if (e.target.type === "checkbox") {
            value = e.target.checked;
            value = !value;
        }
        const user = { ...this.state.user };
        if (e.target.attributes.getNamedItem('object')) {
            const object = e.target.attributes.getNamedItem('object').value;
            user[object][name] = value;
        } else {
            user[name] = value;
        }
        this.setState({ user });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, name, validationRegEx);
        }

        this.validateAllRequiredFields();
    }

    validate = (value, name, validationRegEx) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value)) {
            value === '' ? validation[name]['msg'] = strings.errorRequired : validation[name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[name]['valid'] = isValid;
        this.setState({ validation });
    }

    validateRequiredField = (e) => {
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const name = e.target.name;
            const validation = { ...this.state.validation };
            validation[name]['msg'] = strings.errorRequired;
            validation[name]['valid'] = false;
            this.setState({ validation });
        }
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let i = Object.keys(validation).length;
        for (let type in validation) {
            if (validation[type]['valid']) {
                i--;
            }
        }
        let isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
    }

    updateUser = (userId = '') => {
        this.setMessage('', '', 'loading');
        let method = userId !== '' || this.state.isMyProfile ? 'put' : 'post';
        const updateCreateUser = async () => {
            try {
                let response = await updateOrCreateUser(method, this.state);
                console.log('Update User Response: ', response);
                
                if (response.data.success || response.data.user) {
                    this.setMessage(window.general_strings.msg.yay, strings.msg.success, 'success');
                    if (!this.state.isMyProfile) {
                        this.props.history.push('/client/users');
                    }
                } else {
                    this.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                }

            } catch (error) {
                console.log(error);
            }
        };

        async function updateOrCreateUser(method, data) {
            if (method === 'put' && data.isMyProfile) {
                const dataToSend = {};
                dataToSend.active = data.user.active;
                dataToSend.role = data.user.role;
                dataToSend.first_name = data.user.first_name;
                dataToSend.last_name = data.user.last_name;
                dataToSend.username = data.user.username;
                dataToSend.email = data.user.email;
                if (data.password !== null) {
                    dataToSend.password = data.password;
                    dataToSend.remove_facebook = true;
                    dataToSend.remove_google = true;
                }
                if (data.login_type === 'facebook') {
                    console.log(method, data);
                    dataToSend.facebook_access_token = data.user.facebook_access_token;
                    dataToSend.remove_google = true;
                    dataToSend.password = '';
                }
                if (data.login_type == 'google') {
                    dataToSend.google_id_token = data.user.google_id_token;
                    dataToSend.remove_facebook = true;
                    dataToSend.password = '';
                }
                console.log(dataToSend);
                return await ApiRequest(`/users/current`, {
                    method,
                    data: dataToSend
                });
            } else {
                return await ApiRequest(`/users/${userId}`, {
                    method,
                    data: {
                        active: data.user.active,
                        role: data.user.role,
                        first_name: data.user.first_name,
                        last_name: data.user.last_name,
                        username: data.user.username,
                        email: data.user.email
                    }
                });
            }
        }
        updateCreateUser();
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    facebookCallback = (response) => {
        const nameArray = response.name.split(' ');
        const user = { ...this.state.user };
        user.email = response.email;
        user.first_name = nameArray[0];
        user.last_name = nameArray[1];
        user.facebook_access_token = response.accessToken;
        this.setState(
            {
                user,
                password: null,
                login_type: 'facebook'
            },
            () => {
                this.updateUser(this.props.routeProps.match.params.id)
            }
        );
        this.validateAllRequiredFields();
    }

    googleCallback = (response) => {
        const user = { ...this.state.user };
        user.email = response.profileObj.email;
        user.first_name = response.profileObj.givenName;
        user.last_name = response.profileObj.familyName;
        user.google_id_token = response.tokenId;
        console.log('google response: ', response);
        console.log(response);
        this.setState(
            {
                user,
                password: null,
                login_type: 'google'
            },
            () => {
                this.updateUser(this.props.routeProps.match.params.id)
            }
        );
        this.googleButtonOpacityToggle();
        this.validateAllRequiredFields();
        
    }

    googleButtonOpacityToggle = () => {
        let googleButtonFaded = this.state.googleButtonFaded;
        googleButtonFaded = !googleButtonFaded;
        this.setState({ googleButtonFaded });
    }

    getUser = (userId) => {
        this.setMessage('', '', 'loading');
        if (userId === 'my-profile') {
            userId = 'current';
        }
        (async () => {
            try {
                let response = await getExistingUser();
                this.setState({ user: response.data.user || {} });
                console.log(`Get User --> ${userId}: `, response);
                this.setMessage('', '', '');
            } catch (error) {
                console.log(error);
            }
        })()

        async function getExistingUser() {
            return await ApiRequest(`/users/${userId}`);
        }

        const validation = { ...this.state.validation };
        for (const field in validation) {
            validation[field]['valid'] = true;
        }
        this.setState({ validation });
        this.setState({ isReadyToSubmit: true });
    }

    componentDidMount() {
        if (this.props.routeProps.match.params.id) {
            this.getUser(this.props.routeProps.match.params.id);
        } else if (this.props.routeProps.location.pathname.indexOf('profile') > -1) {
            if (this.props.user.id) {
                this.getUser('my-profile');
                this.setState({
                    isMyProfile: true,
                    title: strings.myProfile
                });
            }
        }
    }

    componentWillReceiveProps(props) {
        /* if (typeof props.user !== 'undefined') {
            this.getUser('my-profile');
            this.setState({
                isMyProfile: true,
                title: strings.myProfile
            });
        } */
    }

    render() {
        return (
            <div className="showtix-section container">
                <div className="row">
                    <div className="col-12 col-lg-8">
                        <h1>{this.state.title}</h1>
                        <Message
                            message={this.state.message}
                        />
                        {!this.state.isMyProfile &&
                            <div>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <div className="showtix-form__checkbox">
                                                <input
                                                    id="tag-inactive"
                                                    className="showtix-input"
                                                    type="checkbox"
                                                    name="active"
                                                    onChange={this.handleChange}
                                                    checked={!this.state.user.active}
                                                    disabled={this.props.user.id === this.state.user.id}
                                                />
                                                <label className="showtix-label" htmlFor="tag-inactive">{strings.inactiveLabel}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="role">{strings.role}*</label>
                                            <div className="showtix-form__select">
                                                <select className="showtix-input"
                                                    id="role"
                                                    name="role"
                                                    value={this.state.user.role}
                                                    onChange={this.handleChange}
                                                    disabled={this.props.user.id === this.state.user.id}
                                                >
                                                    <option value={strings.roles.boxoffice}>{strings.roles.boxoffice}</option>
                                                    <option value={strings.roles.client}>{strings.roles.client}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="first_name">{strings.firstName}*</label>
                                    <div className="showtix-form__input">
                                        <input
                                            id="first_name"
                                            className="showtix-input"
                                            type="text"
                                            name="first_name"
                                            value={this.state.user.first_name}
                                            validation="(^(?!\s*$).+)"
                                            onChange={this.handleChange}
                                            onBlur={this.validateRequiredField}
                                            required
                                        />
                                    </div>
                                    {!this.state.validation.first_name.valid &&
                                        <div className=" showtix-note error">
                                            {this.state.validation.first_name.msg}
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="last_name">{strings.lastName}*</label>
                                    <div className="showtix-form__input">
                                        <input
                                            id="last_name"
                                            className="showtix-input"
                                            type="text"
                                            name="last_name"
                                            value={this.state.user.last_name}
                                            validation="(^(?!\s*$).+)"
                                            onChange={this.handleChange}
                                            onBlur={this.validateRequiredField}
                                            required
                                        />
                                    </div>
                                    {!this.state.validation.last_name.valid &&
                                        <div className=" showtix-note error">
                                            {this.state.validation.last_name.msg}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="last_name">{strings.username}*</label>
                                    <div className="showtix-form__input">
                                        <input
                                            id="username"
                                            className="showtix-input"
                                            type="text"
                                            name="username"
                                            value={this.state.user.username}
                                            validation="(^(?!\s*$).+)"
                                            onChange={this.handleChange}
                                            onBlur={this.validateRequiredField}
                                            readOnly={this.state.isMyProfile ? 'readonly' : false}
                                            required
                                        />
                                    </div>
                                    {!this.state.validation.username.valid &&
                                        <div className=" showtix-note error">
                                            {this.state.validation.username.msg}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className={"showtix-form__group " + (this.state.validation.email.valid === false && this.state.user.email !== '' ? 'showtix-form__error' : '')}>
                                    <label className="showtix-label" htmlFor="email">{strings.orgEmail}*
                                        <span id="tooltip-orgEmail" className="showtix-tooltip">!</span>
                                        <Tooltip placement="top" target="tooltip-orgEmail">
                                            {strings.orgEmailTooltip}
                                        </Tooltip>
                                    </label>
                                    <div className="showtix-form__input">
                                        <input
                                            id="email"
                                            type="text"
                                            className="showtix-input"
                                            placeholder={strings.enterEmail}
                                            name="email"
                                            value={this.state.user.email}
                                            validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                            onChange={this.handleChange}
                                            onBlur={this.validateRequiredField}
                                            required
                                        />
                                    </div>
                                    {!this.state.validation.email.valid &&
                                        <div className=" showtix-note error">
                                            {this.state.validation.email.msg}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        {this.state.isMyProfile &&
                            <div>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="password">{strings.password}</label>

                                            <div className="showtix-form__input">
                                                <input
                                                    className="showtix-input"
                                                    id="password"
                                                    type="password"
                                                    name="password"
                                                    value={this.state.password || ''}
                                                    onChange={this.handleChangePassword}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <hr />
                                        <h1>{strings.orUseSocial}</h1>
                                        <FacebookLogin
                                            appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                                            autoLoad={false}
                                            fields="name,email"
                                            callback={this.facebookCallback}
                                            cssClass="facebook-login-button"
                                            icon="fa-facebook"
                                        />
                                        <GoogleLogin
                                            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                            buttonText="Login"
                                            onRequest={this.googleButtonOpacityToggle}
                                            onSuccess={this.googleCallback}
                                            onFailure={this.googleButtonOpacityToggle}
                                            className={this.googleButtonFaded ? 'google-login-button faded' : 'google-login-button'}
                                        >
                                            <span>
                                                <i className="fa fa-google"></i>
                                                {strings.loginGoogle}
                                            </span>
                                        </GoogleLogin>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="row mt-4">
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <button type="submit"
                                        className="showtix-button showtix-background__primary-1"
                                        disabled={!this.state.isReadyToSubmit}
                                        onClick={() => this.updateUser(this.props.routeProps.match.params.id)}
                                    >
                                        <span>{this.state.button}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(strings.helps && !this.state.isMyProfile) &&
                        <div className="col-12 col-lg-4">
                            {strings.helps.map((help, i) =>
                                <Help help={help} key={i} />
                            )}
                        </div>
                    }
                </div>
            </div>
        )
    }
}

CreateUser.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            client_id: PropTypes.string
        }).isRequired
    })
}

export default withRouter(CreateUser);


// WEBPACK FOOTER //
// ./src/components/CreateUser/CreateUser.js